// var config = {
    
//     qrcodePrefix: "http://web.fondcard.net/weixin/opendoor.php?f="
//     //qrcodePrefix: "http://www.wlqiot.com/weixin/opendoor.php?f="
//   };
export function translateQRcode(qrcode, isGPRS){
    if (qrcode) {
      var qr = qrcode.substring(qrcode.lastIndexOf("=")+1);
      if((qr.length == 17 || qr.length==19) && (qr.indexOf("D") == 0 || qr.indexOf("E") == 0)){

        console.log(`66`,qr.substring(1))
        var pp =qr.substring(1)

       let po = CharToHex(base64ToString(pp)) 
       let encryptstr = po.split(',').join('')
       console.log(encryptstr)

        let bytes = new ArrayBuffer(encryptstr.length/2);

        for (let i = 0; i < encryptstr.length/2; i++) {
            bytes[i] = parseInt(encryptstr.substr(i * 2, 2), 16);
        }
        console.log(`90`,bytes)
        var deviceNo = ((bytes[0] & 0xFF) | ((bytes[1] & 0xFF) << 8) | ((bytes[2] & 0xFF) << 16) | ((bytes[3] & 0xFF) << 24));
        var index = ((bytes[4] & 0xFF) | ((bytes[5] & 0xFF) << 8) | ((bytes[6] & 0xFF) << 16) | ((bytes[7] & 0xFF) << 24));
        var timestamp = ((bytes[8] & 0xFF) | ((bytes[9] & 0xFF) << 8) | ((bytes[10] & 0xFF) << 16) | ((bytes[11] & 0xFF) << 24));
        var serial = deviceNo.toString();
        if(serial.length<8) serial = ("00000000".substr(0, 8-serial.length))+serial;
        var mqttBytes = new Uint8Array(3);
        mqttBytes[0] = bytes[0];
        mqttBytes[1] = bytes[1];
        mqttBytes[2] = bytes[2];
        console.log(`45`,transformArrayBufferToBase64(mqttBytes))
        var mqttSerial = (isGPRS?"G":"W") + transformArrayBufferToBase64(mqttBytes);
        mqttSerial = mqttSerial.replace("+", "@").replace("/", "$");
        return [
          serial, mqttSerial, index, timestamp, qr
        ];
      }
    }
    return false;
  }

  function base64ToString(data) {
    /** Convert Base64 data to a string */
    var toBinaryTable = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
        15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1
    ];
    var result = '';
    var leftbits = 0; 
    var leftdata = 0;                                                                             
    for (var i = 0; i < data.length; i++) {
        var c = toBinaryTable[data.charCodeAt(i) & 0x7f];
        var padding = (data.charCodeAt(i) == '='.charCodeAt(0)); 
        if (c == -1) continue;
        leftdata = (leftdata << 6) | c;
        leftbits += 6;
        if (leftbits >= 8) {
            leftbits -= 8;
            if (!padding)
                result += String.fromCharCode((leftdata >> leftbits) & 0xff);
            leftdata &= (1 << leftbits) - 1;
        }
    }                        
    // if (leftbits)
    //     throw Components.Exception('Corrupted base64 string');
    return result;
}

function CharToHex(str) {
    var out, i, h;
    out = "";
    i = 0;
    while(i < str.length) 
    {
        h = str.charCodeAt(i++).toString(16).toUpperCase();
        if(h.length==1){
            out += "0" +h
        }else{
            out += ""+h;
        }
        out +=(i > 0 && i % 8 == 0)?"":",";
    }
    return out;
}

/*
    数组 转base64
    @buffer 数组
*/ 
function transformArrayBufferToBase64 (buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    for (var len = bytes.byteLength, i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

// 标准时间转化成日期
export function formatDateTime (date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    return y + '-' + m + '-' + d+' '+h+':'+minute;
}

// 时间戳转换成日期格式


export function timestampToTime(timestamp){
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    // var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
    
    let strDate = M+D+h+m+s;
    return strDate;
}
// 二维码开门解码
export function buildUserQRcode(userId, index, timestamp){
    var bytes = new Uint8Array(12);
    bytes[0] = ((userId) & 0xFF);
    bytes[1] = ((userId >> 8) & 0xFF);
    bytes[2] = ((userId >> 16) & 0xFF);
    bytes[3] = ((userId >> 24) & 0xFF);
    bytes[4] = ((index) & 0xFF);
    bytes[5] = ((index >> 8) & 0xFF);
    bytes[6] = ((index >> 16) & 0xFF);
    bytes[7] = ((index >> 24) & 0xFF);
    bytes[8] = ((timestamp) & 0xFF);
    bytes[9] = ((timestamp >> 8) & 0xFF);
    bytes[10] = ((timestamp >> 16) & 0xFF);
    bytes[11] = ((timestamp >> 24) & 0xFF);
    return "M" + transformArrayBufferToBase64(bytes);  
  }


// 截取url？后面的内容

